export default function IconShow({ height, width, fill, blur }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="icon"
      width={width ? width : height ? height : 20}
      height={height ? height : width ? width : 20}
      viewBox="0 0 12 20"
    >
      <defs>
        <filter
          id="Shape"
          x="0"
          y="0"
          width="50.298"
          height="50.298"
          filterUnits="userSpaceOnUse"
        >
          <feOffset input="SourceAlpha" />
          <feGaussianBlur stdDeviation="5" result="blur" />
          <feFlood floodColor={blur && "#00fe78"} />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_29" data-name="Group 29">
        <path
          id="visibility_FILL1_wght700_GRAD0_opsz48"
          d="M7.5,13.586a2.309,2.309,0,0,0,2.323-2.323A2.309,2.309,0,0,0,7.5,8.941,2.309,2.309,0,0,0,5.18,11.263,2.309,2.309,0,0,0,7.5,13.586Zm0-1.011a1.306,1.306,0,1,1,.929-.383A1.265,1.265,0,0,1,7.5,12.575Zm0,3.1A6.3,6.3,0,0,1,3.923,14.6a7.459,7.459,0,0,1-2.514-2.828.774.774,0,0,1-.082-.239,1.43,1.43,0,0,1-.027-.266,1.39,1.39,0,0,1,.027-.273.975.975,0,0,1,.082-.246A7.487,7.487,0,0,1,3.923,7.929,6.3,6.3,0,0,1,7.5,6.85a6.3,6.3,0,0,1,3.58,1.079A7.487,7.487,0,0,1,13.6,10.744a.975.975,0,0,1,.082.246,1.39,1.39,0,0,1,.027.273,1.43,1.43,0,0,1-.027.266.774.774,0,0,1-.082.239A7.459,7.459,0,0,1,11.083,14.6,6.3,6.3,0,0,1,7.5,15.677Z"
          fill={fill ? fill : "#6C7270"}
        />
      </g>
    </svg>
  );
}
